import styled from 'styled-components';

import colors from 'themes/Main';

const { white } = colors;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  background-color: ${white};
  padding: 16px 0;
`;
